import AttendanceSearch from "./AttendanceSearch";
import Detail from "./Detail";
import List from "./List";

const routes = [
    {
        path: 'attendance',
        element: <List />
    },
    {
        path: 'attendance/search',
        element: <AttendanceSearch />
    },
    {
        path: 'attendance/:id',
        element: <Detail />
    }
]
export default routes;